import { FILTER_HIGHLIGHT_TASK_ALARM_UUID } from "constants/task";
import { useQuery } from "hooks/useQuery";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

export const Deadline = () => {
  const { isAdmin, isCustomer } = useRoleBasedView();
  const params = useParams<{ groupId: string }>();
  const groupId = params.groupId;
  const history = useHistory();
  const query = useQuery();
  const highlight = query.get(FILTER_HIGHLIGHT_TASK_ALARM_UUID);
  const entity = query.get("entity");
  const season = query.get("season");
  const highlightParam = highlight
    ? `&${new URLSearchParams({
        [FILTER_HIGHLIGHT_TASK_ALARM_UUID]: highlight,
        entity: entity ?? "",
        season: season ?? "",
      }).toString()}`
    : "";

  useEffect(() => {
    if (isCustomer) {
      history.push(`/tax/filings?FILING_STATUS=ALL${highlightParam}`);
    }
    if (isAdmin) {
      const filingStatus = highlight ? "ALL" : "ONGOING";
      history.push(
        `/admin/crm/${groupId}/new-filings?FILING_STATUS=${filingStatus}${highlightParam}`
      );
    }
  }, [groupId, highlightParam]);

  return null;
};
